import peopleModel from 'models/people/people-model';

const AddPeoplePrompt = {
    view: ({attrs: {assetId}}) => <div class="linked-text" onclick={() => peopleModel.routeToPeopleTab(assetId)}><i class="icon-plus" /> Add a person</div>
};

export default AddPeoplePrompt;
